import React, { useEffect, useState } from 'react'
import axiosInstance from '../../config/ProtectedAxios';
import ReactPaginate from 'react-paginate';
import moment from 'moment';

export default function RecentTransactions() {
    const userToken = localStorage.getItem("userToken");
    const [Transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        total: 0,
        page: 1,
        limit: 20,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
    });
    const protectedAxios = axiosInstance(userToken);

    // Filter states
    const [filters, setFilters] = useState({
        search: '',
        transactionStatus: '',
        transactionType: '',
        paymentMode: '',
        dateRange: '',
    });

    const [currentPage, setCurrentPage] = useState(0);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
        setCurrentPage(0); // Reset to first page when filter changes
    };

    const fetchTransactions = async () => {
        try {
            setLoading(true);
            const page = currentPage + 1; // ReactPaginate uses 0-based, API uses 1-based
            const params = new URLSearchParams({
                page: page.toString(),
                limit: '20',
            });

            // Add filters to params
            if (filters.search) params.append('search', filters.search);
            if (filters.transactionStatus) params.append('transactionStatus', filters.transactionStatus);
            if (filters.transactionType) params.append('transactionType', filters.transactionType);
            if (filters.paymentMode) params.append('paymentMode', filters.paymentMode);
            if (filters.dateRange) params.append('dateRange', filters.dateRange);

            const res = await protectedAxios.get(`/all/transactions?${params.toString()}`);

            if (res.data.status && res.data.data) {
                setTransactions(res.data.data);
                setPagination(res.data.pagination || {
                    total: 0,
                    page: 1,
                    limit: 20,
                    totalPages: 0,
                    hasNextPage: false,
                    hasPrevPage: false,
                });
            }
        } catch (err) {
            setTransactions([]);
        } finally {
            setLoading(false);
        }
    }

    // Debounce search input and fetch when filters change
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchTransactions();
        }, filters.search ? 500 : 0);

        return () => clearTimeout(timeoutId);
    }, [filters.search, filters.transactionStatus, filters.transactionType, filters.paymentMode, filters.dateRange, currentPage])

    const getUserDisplayName = (user) => {
        if (!user) return 'N/A';
        if (user.businessName) return user.businessName;
        if (user.firstName || user.lastName) {
            return `${user.firstName || ''} ${user.lastName || ''}`.trim();
        }
        return user.email || 'N/A';
    };

    return (
        <div style={{ margin: "100px auto", maxWidth: "1400px", padding: "0 20px" }}>
            <h1 id="head_dash" style={{ margin: "30px 0", textAlign: "left" }}>
                All Transactions
            </h1>

            <div
                className="shadow-box admin-box"
                style={{ width: "95%", marginTop: "10px" }}
            >
                {/* Transaction Stats Summary */}
                <div style={{ display: "flex", gap: "15px", marginBottom: "20px", flexWrap: "wrap", width: "95%" }}>
                    <div className="shadow-box" style={{ flex: "1", minWidth: "150px", padding: "15px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: 0 }}>
                        <h3 style={{ fontSize: "12px", color: "#aaa", margin: "0 0 5px 0", textTransform: "uppercase" }}>Total Transactions</h3>
                        <h2 style={{ fontSize: "24px", margin: "0", color: "#fff" }}>{pagination.total || 0}</h2>
                    </div>
                    <div className="shadow-box" style={{ flex: "1", minWidth: "150px", padding: "15px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: 0 }}>
                        <h3 style={{ fontSize: "12px", color: "#aaa", margin: "0 0 5px 0", textTransform: "uppercase" }}>Success / Failed</h3>
                        <div style={{ display: "flex", gap: "10px", alignItems: "baseline" }}>
                            <h2 style={{ fontSize: "24px", margin: "0", color: "#3ca151" }}>
                                {Transactions.filter(t => t.transactionStatus === 'success').length}
                            </h2>
                            <span style={{ color: "#666" }}>/</span>
                            <h2 style={{ fontSize: "24px", margin: "0", color: "#f77269" }}>
                                {Transactions.filter(t => t.transactionStatus === 'failed').length}
                            </h2>
                        </div>
                    </div>
                    <div className="shadow-box" style={{ flex: "1", minWidth: "150px", padding: "15px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: 0 }}>
                        <h3 style={{ fontSize: "12px", color: "#aaa", margin: "0 0 5px 0", textTransform: "uppercase" }}>Total DM Amount</h3>
                        <h2 style={{ fontSize: "24px", margin: "0", color: "#fff" }}>
                            {Transactions.reduce((acc, curr) => acc + (parseFloat(curr.amount) || 0), 0).toFixed(0)}
                        </h2>
                    </div>
                    <div className="shadow-box" style={{ flex: "1", minWidth: "150px", padding: "15px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: 0 }}>
                        <h3 style={{ fontSize: "12px", color: "#aaa", margin: "0 0 5px 0", textTransform: "uppercase" }}>Today's Transactions</h3>
                        <h2 style={{ fontSize: "24px", margin: "0", color: "#3ca151" }}>
                            {Transactions.filter(t => moment(t.createdDate).isSame(moment(), 'day')).length}
                        </h2>
                    </div>
                </div>

                {/* Filters Section */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "15px",
                        marginBottom: "20px",
                        padding: "15px",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        borderRadius: "8px",
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search by ID, email, or name..."
                        value={filters.search}
                        onChange={(e) => handleFilterChange('search', e.target.value)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            flex: "1",
                            minWidth: "200px",
                        }}
                    />
                    <select
                        value={filters.transactionStatus}
                        onChange={(e) => handleFilterChange('transactionStatus', e.target.value)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            minWidth: "150px",
                        }}
                    >
                        <option value="">All Status</option>
                        <option value="success">Success</option>
                        <option value="pending">Pending</option>
                        <option value="failed">Failed</option>
                    </select>
                    <select
                        value={filters.transactionType}
                        onChange={(e) => handleFilterChange('transactionType', e.target.value)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            minWidth: "150px",
                        }}
                    >
                        <option value="">All Types</option>
                        <option value="send">Send</option>
                        <option value="receive">Receive</option>
                        <option value="buy">Buy</option>
                        <option value="donation">Donation</option>
                    </select>
                    <select
                        value={filters.paymentMode}
                        onChange={(e) => handleFilterChange('paymentMode', e.target.value)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            minWidth: "150px",
                        }}
                    >
                        <option value="">All Payment Modes</option>
                        <option value="DM">DM</option>
                        <option value="WALLET">WALLET</option>
                        <option value="PAYPAL">PayPal</option>
                        <option value="CARD">Card</option>
                        <option value="System">System</option>
                    </select>
                    <select
                        value={filters.dateRange}
                        onChange={(e) => handleFilterChange('dateRange', e.target.value)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            minWidth: "150px",
                        }}
                    >
                        <option value="">All Time</option>
                        <option value="1month">Last Month</option>
                        <option value="3months">Last 3 Months</option>
                        <option value="6months">Last 6 Months</option>
                        <option value="1year">Last Year</option>
                        <option value="2years">Last 2 Years</option>
                    </select>
                </div>

                <hr style={{ marginBottom: "20px" }} />

                {loading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <p>Loading transactions...</p>
                    </div>
                ) : (
                    <>
                        <div style={{ marginBottom: "15px", color: "#666" }}>
                            Showing {Transactions.length} of {pagination.total} transactions
                        </div>
                        <div className="table" style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Transaction ID</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Sender</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Receiver</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Amount</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Type</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Payment Mode</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Status</th>
                                        <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd", whiteSpace: "nowrap" }}>Created On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Transactions.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                                                No transactions found
                                            </td>
                                        </tr>
                                    ) : (
                                        Transactions.map((item, index) => (
                                            <tr key={item._id || index} style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {item.transId || item._id?.toString().slice(-8) || 'N/A'}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {getUserDisplayName(item.senderId)}
                                                    {item.senderId?.email && (
                                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                                            {item.senderId.email}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {getUserDisplayName(item.recipientUserId)}
                                                    {item.recipientUserId?.email && (
                                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                                            {item.recipientUserId.email}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left", fontWeight: "500" }}>
                                                    {item.amount ? parseFloat(item.amount).toFixed(3) : '0.000'} DM
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {item.transactionType || 'N/A'}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {item.paymentMode || 'N/A'}
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    <span
                                                        style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            backgroundColor:
                                                                item.transactionStatus === 'success'
                                                                    ? '#d4edda'
                                                                    : item.transactionStatus === 'pending'
                                                                        ? '#fff3cd'
                                                                        : '#f8d7da',
                                                            color:
                                                                item.transactionStatus === 'success'
                                                                    ? '#155724'
                                                                    : item.transactionStatus === 'pending'
                                                                        ? '#856404'
                                                                        : '#721c24',
                                                        }}
                                                    >
                                                        {item.transactionStatus || 'N/A'}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "12px", textAlign: "left" }}>
                                                    {item.createdDate
                                                        ? moment(item.createdDate).format("DD-MM-YYYY hh:mm A")
                                                        : 'N/A'}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {pagination.totalPages > 1 && (
                            <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={pagination.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageChange}
                                forcePage={currentPage}
                                containerClassName={"pagination"}
                                activeClassName={"active"}
                                disabledClassName={"disabled"}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    )
}